var _circle, _rect, _rect2, _g, _circle2, _ellipse, _path, _path2, _path3, _path4, _circle3, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#E3E4E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 32.7383,
    width: 79.2615,
    height: 79.2615,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3526_891372",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 32,
    width: 81,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 32.7383,
    width: 79.2615,
    height: 79.2615,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3526_891372)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.6924,
    y: 58.0103,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4976,
    y: 58.0103,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3027,
    y: 58.0103,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1077,
    y: 58.0103,
    width: 12.0615,
    height: 12.0615,
    fill: "#D5D6D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6924,
    y: 74.6665,
    width: 12.0615,
    height: 12.0615,
    fill: "#FF7200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4976,
    y: 74.6665,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3027,
    y: 74.6665,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1077,
    y: 74.6665,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6924,
    y: 91.3232,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4976,
    y: 91.3232,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3027,
    y: 91.3232,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1077,
    y: 91.3232,
    width: 12.0615,
    height: 12.0615,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 34.7383C30.8 33.6337 31.6955 32.7383 32.8 32.7383H108.062C109.166 32.7383 110.062 33.6337 110.062 34.7383V51.1178H30.8V34.7383Z",
    fill: "#0071DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.8171,
    y: 68.7139,
    width: 56.8615,
    height: 56.8615,
    transform: "rotate(-45 73.8171 68.7139)",
    fill: "#9B9B9B"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.277,
    cy: 51.1179,
    r: 28.7179,
    fill: "#211E1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.2771,
    cy: 51.1179,
    rx: 24.2351,
    ry: 24.5153,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.417 69.7244C97.2957 69.7244 98.008 70.4436 98.008 71.3308C98.008 72.2179 97.2957 72.9371 96.417 72.9371C95.5384 72.9371 94.826 72.2179 94.826 71.3308C94.826 70.4436 95.5384 69.7244 96.417 69.7244ZM84.9327 67.8274C85.3763 67.0591 86.3527 66.7925 87.1137 67.2318C87.8747 67.6711 88.1319 68.6501 87.6884 69.4184C87.2448 70.1867 86.2683 70.4534 85.5074 70.0141C84.7464 69.5747 84.4891 68.5957 84.9327 67.8274ZM105.72 67.2318C106.481 66.7925 107.458 67.0591 107.901 67.8274C108.345 68.5957 108.088 69.5747 107.327 70.0141C106.566 70.4534 105.589 70.1867 105.146 69.4184C104.702 68.6501 104.959 67.6711 105.72 67.2318ZM112.531 60.4211C112.97 59.6601 113.949 59.4028 114.718 59.8464C115.486 60.29 115.753 61.2664 115.313 62.0274C114.874 62.7884 113.895 63.0456 113.127 62.6021C112.358 62.1585 112.092 61.182 112.531 60.4211ZM78.1165 59.8464C78.8848 59.4028 79.8638 59.6601 80.3032 60.4211C80.7425 61.182 80.4758 62.1585 79.7075 62.6021C78.9392 63.0456 77.9602 62.7884 77.5209 62.0274C77.0816 61.2664 77.3482 60.29 78.1165 59.8464ZM116.63 49.5267C117.517 49.5267 118.236 50.239 118.236 51.1177C118.236 51.9964 117.517 52.7087 116.63 52.7087C115.743 52.7087 115.024 51.9964 115.024 51.1177C115.024 50.239 115.743 49.5267 116.63 49.5267ZM76.204 49.5267C77.0912 49.5267 77.8103 50.239 77.8103 51.1177C77.8103 51.9964 77.0912 52.7087 76.204 52.7087C75.3168 52.7087 74.5977 51.9964 74.5977 51.1177C74.5977 50.239 75.3168 49.5267 76.204 49.5267ZM77.5209 40.208C77.9602 39.4471 78.9392 39.1898 79.7075 39.6333C80.4758 40.0769 80.7425 41.0534 80.3032 41.8143C79.8638 42.5753 78.8848 42.8326 78.1165 42.389C77.3482 41.9454 77.0816 40.969 77.5209 40.208ZM113.127 39.6333C113.895 39.1898 114.874 39.4471 115.313 40.208C115.753 40.969 115.486 41.9454 114.718 42.389C113.949 42.8326 112.97 42.5753 112.531 41.8143C112.092 41.0534 112.358 40.0769 113.127 39.6333ZM105.146 32.8173C105.589 32.049 106.566 31.7823 107.327 32.2217C108.088 32.661 108.345 33.64 107.901 34.4083C107.458 35.1766 106.481 35.4433 105.72 35.0039C104.959 34.5646 104.702 33.5856 105.146 32.8173ZM85.5074 32.2217C86.2683 31.7823 87.2448 32.049 87.6884 32.8173C88.1319 33.5856 87.8747 34.5646 87.1137 35.0039C86.3527 35.4433 85.3763 35.1766 84.9327 34.4083C84.4891 33.64 84.7464 32.661 85.5074 32.2217ZM96.417 29.2983C97.2957 29.2983 98.008 30.0175 98.008 30.9047C98.008 31.7918 97.2957 32.511 96.417 32.511C95.5384 32.511 94.826 31.7918 94.826 30.9047C94.826 30.0175 95.5384 29.2983 96.417 29.2983Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3002 36.4229L97.2436 52.7919L96.8445 53.205L79.9011 36.8359L80.3002 36.4229Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9386 35.2876V52.7915L89.137 62.6486L87.5476 61.0682L96.6972 51.8668V35.2876H98.9386Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.538 33.8872V51.214L87.7273 60.9681L86.147 59.3786L95.2966 50.2817V33.8872H97.538Z",
    fill: "#211E1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.277,
    cy: 51.1176,
    r: 1.54096,
    fill: "#211E1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7396 34.7417L96.6831 51.1108L96.284 51.5238L79.3406 35.1548L79.7396 34.7417Z",
    fill: "#F13C12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b16949991b960fcf6feb3292f46edfe7.svg";
export { ForwardRef as ReactComponent };